var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "#EFEFF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 89C97.1208 89 111 70.4565 111 50.2162C111 32.976 97.1208 19 80 19C62.8792 19 49 32.976 49 50.2162C49 70.4565 62.8792 89 80 89Z",
    fill: "#B0B0B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.91 137.039C157.931 144.319 160 152.121 160 160H0C0 152.121 2.06926 144.319 6.08963 137.039C10.11 129.759 16.0028 123.145 23.4315 117.574C30.8601 112.002 39.6793 107.583 49.3853 104.567C59.0914 101.552 69.4942 100 80 100C90.5057 100 100.909 101.552 110.615 104.567C120.321 107.583 129.14 112.002 136.569 117.574C143.997 123.145 149.89 129.759 153.91 137.039Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlank);
export default __webpack_public_path__ + "static/media/blank.6b56053c7a5a5fe7b30df4765a67cce2.svg";
export { ForwardRef as ReactComponent };